module.exports = __webpack_public_path__ + "static/media/acura-app-icon.5ffe0ad1.svg";